import { render, staticRenderFns } from "./IngredientSelect.vue?vue&type=template&id=0e41983c&scoped=true&"
import script from "./IngredientSelect.vue?vue&type=script&lang=js&"
export * from "./IngredientSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e41983c",
  null
  
)

export default component.exports